import React from "react";
import PropTypes from "prop-types";
import "./pageContentStyles.css";

export default function PageContent({ children }) {
  return <div className="page-content">{children}</div>;
}
PageContent.propTypes = { children: PropTypes.any.isRequired };
